var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeBarre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 36,
    viewBox: "0 0 237 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12238 0.337891H0V35.1065H5.12238V0.337891Z",
    fill: "#0E0B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1075 0.337891H8.54492V35.1065H11.1075V0.337891Z",
    fill: "#0E0B26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1829 0.337891H14.0605V35.1065H19.1829V0.337891Z",
    fill: "#0E0B26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4837 0.337891H21.3613V35.1065H26.4837V0.337891Z",
    fill: "#0E0B26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8997 0.337891H48.7773V35.1065H53.8997V0.337891Z",
    fill: "#0E0B26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2884 0.337891H57.166V35.1065H62.2884V0.337891Z",
    fill: "#0E0B26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8585 0.337891H29.2959V35.1065H31.8585V0.337891Z",
    fill: "#0E0B26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3009 0.337891H33.7383V35.1065H36.3009V0.337891Z",
    fill: "#0E0B26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6769 0.337891H39.1143V35.1065H41.6769V0.337891Z",
    fill: "#0E0B26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1193 0.337891H43.5566V35.1065H46.1193V0.337891Z",
    fill: "#0E0B26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1195 0.337891H63.9971V35.1065H69.1195V0.337891Z",
    fill: "#0E0B26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5646 0.337891H71.002V35.1065H73.5646V0.337891Z",
    fill: "#0E0B26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.006 0.337891H75.4434V35.1065H78.006V0.337891Z",
    fill: "#0E0B26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9417 0.337891H80.8193V35.1065H85.9417V0.337891Z",
    fill: "#0E0B26"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9269 0.337891H89.3643V35.1065H91.9269V0.337891Z",
    fill: "#0E0B26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.002 0.337891H94.8799V35.1065H100.002V0.337891Z",
    fill: "#0E0B26"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.302 0.337891H102.18V35.1065H107.302V0.337891Z",
    fill: "#0E0B26"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.681 0.337891H110.118V35.1065H112.681V0.337891Z",
    fill: "#0E0B26"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.12 0.337891H114.558V35.1065H117.12V0.337891Z",
    fill: "#0E0B26"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M124.121 0.337891H118.999V35.1065H124.121V0.337891Z",
    fill: "#0E0B26"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.107 0.337891H127.544V35.1065H130.107V0.337891Z",
    fill: "#0E0B26"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M138.185 0.337891H133.062V35.1065H138.185V0.337891Z",
    fill: "#0E0B26"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.483 0.337891H140.36V35.1065H145.483V0.337891Z",
    fill: "#0E0B26"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M172.9 0.337891H167.777V35.1065H172.9V0.337891Z",
    fill: "#0E0B26"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M181.291 0.337891H176.169V35.1065H181.291V0.337891Z",
    fill: "#0E0B26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M150.861 0.337891H148.299V35.1065H150.861V0.337891Z",
    fill: "#0E0B26"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.303 0.337891H152.74V35.1065H155.303V0.337891Z",
    fill: "#0E0B26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M160.679 0.337891H158.116V35.1065H160.679V0.337891Z",
    fill: "#0E0B26"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M165.12 0.337891H162.558V35.1065H165.12V0.337891Z",
    fill: "#0E0B26"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M188.121 0.337891H182.999V35.1065H188.121V0.337891Z",
    fill: "#0E0B26"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M192.564 0.337891H190.001V35.1065H192.564V0.337891Z",
    fill: "#0E0B26"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M197.005 0.337891H194.442V35.1065H197.005V0.337891Z",
    fill: "#0E0B26"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M204.941 0.337891H199.818V35.1065H204.941V0.337891Z",
    fill: "#0E0B26"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M210.929 0.337891H208.366V35.1065H210.929V0.337891Z",
    fill: "#0E0B26"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M219.004 0.337891H213.882V35.1065H219.004V0.337891Z",
    fill: "#0E0B26"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M226.301 0.337891H221.179V35.1065H226.301V0.337891Z",
    fill: "#0E0B26"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M231.681 0.337891H229.118V35.1065H231.681V0.337891Z",
    fill: "#0E0B26"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M236.122 0.337891H233.56V35.1065H236.122V0.337891Z",
    fill: "#0E0B26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeBarre);
export default __webpack_public_path__ + "static/media/codeBarre.c4eb685db183c128c537799f1c1605f7.svg";
export { ForwardRef as ReactComponent };